"use strict";

let instance = null;
import store from "@/store";
import io from "socket.io-client";
import Config from "../../config/index";
import EventBus from "../EventBus";
import { Gamedock } from "../tracking/Gamedock";
import {
  AZC_LOGIN_ERROR,
  AZC_LOGIN_SUCCESS,
  NOTIFICATION_LIST,
  PAYMENT_COMPLETED
} from "./Events";

const PLAY_CHANNEL = `${Config.NETWORK_URL}/play`;

/**
 * EventBus
 */
class Network {
  /**
   * Constructor of EventBus.
   * @return {*}
   */
  constructor(args) {
    // Make this a singleton.
    if (instance) return instance;
    else instance = this;

    this.uid = args.uid;
    this.game = args.game;
    this.token = args.token;

    this.EventBus = new EventBus();
    this.Gamedock = new Gamedock();

    this._connect();
  }

  _connect() {
    this.socket = io(
      `${PLAY_CHANNEL}?uid=${this.uid}&game=${this.game.gameName}&token=${this.token}`
    );

    this.socket.on("connect", this._onConnect);
    this.socket.on("connect_error", this._onError);
    this.socket.on(`${PAYMENT_COMPLETED}`, this._onPaymentCompleted.bind(this));
    this.socket.on(`${NOTIFICATION_LIST}`, this._onNotificationList.bind(this));
    this.socket.on(`${AZC_LOGIN_SUCCESS}`, this._onAzcLoginSuccess.bind(this));
    this.socket.on(`${AZC_LOGIN_ERROR}`, this._onAzcLoginError.bind(this));
  }

  _onConnect() {
    console.log("Connected to the Network.");
  }

  _onError() {
    console.log("Couldn't connect to the Network.");
  }
  _onPaymentCompleted(args) {
    this.EventBus.broadcast("GAME_PAYMENT_COMPLETED", args);

    // Track payment on Gamedock for Tableau
    this.Gamedock.payment({
      pageId: this.game.gdGameId,
      isAuthorized: true,
      globalUserId: args.uid,
      transactionId: args.transactionId,
      packageName: args.packageName,
      revenue: parseFloat(args.revenue),
      currency: args.currency,
      paymentStatus: args.paymentStatus,
      paymentMethod: args.paymentMethod,
      paymentProvider: args.paymentProvider
    });
  }

  _onNotificationList(args) {
    store.commit("NOTIFICATION_TOTAL", args.totalUnseen);
    store.commit("NOTIFICATION_LIST", JSON.stringify(args.result));
  }

  _onAzcLoginSuccess(args) {
    console.log(args);
    this.EventBus.broadcast("AZC_LOGIN_SUCCESS", args);
  }

  _onAzcLoginError(args) {
    console.log(args);
    this.EventBus.broadcast("AZC_LOGIN_ERROR", args);
  }
}

export default Network;
